import React from 'react'
import 'react-quill-new/dist/quill.snow.css'
import './quill-renderer.scss'

const QuillRenderer = ({ htmlContent, style = {} }) => {
    const normalizedHtmlContent = (htmlContent || '').replace(/(&nbsp;|&#160;|&#xA0;|\u00a0)/gi, ' ')

    return (
        <div className='quill-renderer ql-container'>
            <div className='ql-snow'>
                <div
                    className='ql-editor'
                    style={{ wordBreak: 'normal', overflowWrap: 'break-word', ...style }}
                    dangerouslySetInnerHTML={{ __html: normalizedHtmlContent }}
                />
            </div>
        </div>
    )
}

export default QuillRenderer
